import { colord } from 'colord';
import {
  Colors,
  ColorValue,
  ZapCardSection as ZapCardSectionZDS,
  ZapCardSectionProps,
} from '@zapier/design-system';

import { Section } from '../../Section/Section';
import { BackgroundColorKeys } from '../../Section/background';
import {
  CtaGoalType,
  CtaNameType,
  CTAType,
  EventName,
  SectionName,
  useTrackEvent,
  useAvroTracking,
} from '../../../observability';
import { useUnregisteredProps } from './ZapCardSection.transformer';
import { BuilderComponentProps } from '../../../builder';

export type Item = ZapCardSectionProps['items'][0] & {
  ctaGoal: CtaGoalType;
  ctaName: CtaNameType;
  zapTemplateID?: string;
};

export type Props = {
  background?: BackgroundColorKeys;
  items: Item[];
  layout: ZapCardSectionProps['layout'];
};

export function ZapCardSection(props: Props & BuilderComponentProps) {
  const { items } = useUnregisteredProps(props);

  return (
    <Section
      background={props.background}
      contentWidth="custom"
      layerName={props.builderBlock?.layerName}
      sectionToTrack={SectionName.ZapCardSection}
    >
      <ZapCards items={items || []} layout={props.layout} />
    </Section>
  );
}
// Have to create an inner component in order for useTrackEvent to be invoked in TrackingProvider
function ZapCards({ items, layout }: Props) {
  const trackEvent = useTrackEvent();
  const { emitCTAClickEvent } = useAvroTracking();

  const zapCardItems = items.map((item, index) => ({
    ...item,
    services: item.services || [],
    color: item.color
      ? (colord(item.color).toHex() as ColorValue)
      : Colors.white,
    key: `zap_card_${index}`,
    onClick: () => {
      emitCTAClickEvent({
        text: item.title,
        href: item.href,
        section: SectionName.ZapCardSection,
        type: CTAType.zap_card_link,
      });
      trackEvent(EventName.CALL_TO_ACTION, {
        path: window.location.pathname,
        from_path: document.referrer,
        cta_name: item.ctaName,
        cta_goal: item.ctaGoal,
        cta_raw_text: item.title,
        link_destination: item.href,
      });
    },
  }));
  return <ZapCardSectionZDS items={zapCardItems} layout={layout} />;
}
